<template>
  <d-card class="card-small mb-4 h-100">
    <!-- Card Header -->
    <d-card-header class="border-bottom">
      <d-row class="align-items-center">
        <d-col cols="12" md="6">
          <h6 class="m-0">Etapa final</h6>
        </d-col>
        <d-col cols="12" md="6" class="text-right">
          <quotation-buttons :showPrintQuotation="false" :quotation="quotation"></quotation-buttons>
        </d-col>
      </d-row>
    </d-card-header>

     <d-card-body class="d-flex flex-column">
        <p class="mb-0">Visualizar arquivos</p>
        <div class="d-flex flex-fill flex-column justify-content-center align-items-center">
          <d-form-row class="flex-1">
            <!-- Access type -->
            <ul class="download-list mb-5">
              <li @click="printTechnicalAvaliation">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"/></svg>
                <span>Avaliação técnica</span>
              </li>
              <li v-if="canViewQuotation" @click="printQuotation">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"/></svg>
                <span>Orçamento</span>
              </li>

              <li>
                <step-upload-image
                  :image="model.files.contract"
                  :index="0"
                  @update:image="updateImage"
                  file-type="contract"
                />
                <span>Contrato</span>
              </li>
            </ul>
          </d-form-row>
        </div>
    </d-card-body>

    <d-card-footer class="border-top">
      <d-form-row>
        <!-- Quotation approved -->
        <d-col cols="12" md="3" class="form-group">
          <label for="name">Orçamento aprovado</label>
          <template v-if="!approvedQuotation">
            <d-select v-model="model.group" :state="hasErrorFiled('group_id')">
              <option :value="group" v-for="group in quotation.groups" :key="group.id">{{ group.name }}</option>
            </d-select>
            <d-form-invalid-feedback>O orçamento aprovado é obrigatório</d-form-invalid-feedback>
          </template>
          <d-input v-else type="text" disabled :value="quotation.groups[0].name"/>
        </d-col>
        <!-- Payment -->
        <d-col cols="12" md="3" class="form-group">
          <label for="name">Forma de pagamento</label>
          <template v-if="!approvedQuotation">
            <d-select v-model="model.installment_id" :state="hasErrorFiled('installment_id')">
              <option :value="payment.value" v-for="payment in payments" :key="payment.id">{{ payment.label }}</option>
            </d-select>
            <d-form-invalid-feedback>Forma de pagamento é obrigatório</d-form-invalid-feedback>
          </template>

          <d-input v-else-if="model.group" type="text" disabled :value="payments[0].label"/>
        </d-col>
      </d-form-row>
      <d-form-row>
        <d-col class="d-flex justify-content-end">
          <button v-if="quotation.status.slug !== 'approved-payment'" class="btn btn-secondary" @click="declineQuotation">Não deu negócio :(</button>
          <button v-if="quotation.status.slug == 'approved-admin'" class="btn btn-success ml-4 text-uppercase" @click="approveQuotation">Marcar Gol <i class=" fas fa-futbol"></i></button>
          <button v-if="quotation.status.slug == 'approved'" class="btn btn-info ml-4 text-uppercase" @click="pendingQuotation">Marcar como Pagamento pendente <i class=" fas fa-dollar-sign"></i></button>
          <button v-else-if="quotation.status.slug == 'pending-payment'" class="btn btn-info ml-4 text-uppercase" @click="paidQuotation">Marcar como pago <i class=" fas fa-dollar-sign"></i></button>
        </d-col>
      </d-form-row>
    </d-card-footer>
    <approved-modal :model="quotation" />
    <payment-approved-modal :model="quotation" />
    <pending-modal :model="quotation" />
    <import-modals/>
  </d-card>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { cloneDeep, openPdf, catchPdf } from '_utils';
import Datepicker from '_shared/Datepicker.vue';
import ImportModals from '_modules/quotation/components/ImportModals.vue';
import MixinValidateForm from '_common/mixins/ValidateForm';
import QuotationService from '_services/rest/modules/quotation';
import QuotationButtons from '_modules/quotation/components/QuotationButtons.vue';
import UserPermissions from '_common/mixins/UserPermissions';
import NoPermission from './NoPermission.vue';
import { FILE, MODEL, _LOAD_MODEL_ } from './QuotationModel';
import ApprovedModal from './modal/ApprovedModal.vue';
import PaymentApprovedModal from './modal/PaymentApprovedModal.vue';
import PendingModal from './modal/PendingModal.vue';

import StepUploadImage from './StepUploadImage.vue';

export default {
  name: 'Step-approved',
  mixins: [MixinValidateForm, UserPermissions],
  data() {
    return {
      model: {
        id: this.$route.params.quotationId,
        files: [{ contract: cloneDeep(FILE) }],
        group: null,
        group_id: null,
        installment_id: null,
      },
      errors: {
        group_id: { required: false },
        installment_id: { required: false },
      },
    };
  },
  computed: {
    approvedQuotation() {
      return ['approved', 'approved-payment'].includes(this.quotation.status.slug);
    },
    quotation() {
      const { quotation } = this.$store.state.quotation;
      return quotation || cloneDeep(MODEL);
    },
    payments() {
      if (!this.model.group) return [];
      const payments = this.model.group.installments ? this.model.group.installments.map(payment => {
        const entry = payment.entree_type === 'pct' ? `${payment.entree_value}%` : `R$ ${payment.entree_value}`;
        return {
          value: payment.id,
          label: `${entry} entrada, saldo ${payment.parcel}x`,
        };
      }) : [];
      payments.push({ value: '0', label: 'À vista' });
      return payments;
    },
    canViewQuotation() {
      return this.quotation.status?.slug !== 'waiting' || this.canApproveQuotation(this.quotation);
    },
  },
  watch: {
    '$store.state.quotation.quotation': {
      immediate: true,
      handler(quotation) {
        if (!quotation || !quotation.groups)
          return;

        [this.model.group] = quotation.groups;
        const contract = quotation.files.contract ? quotation.files.contract[0] : cloneDeep(FILE);
        this.model.files.contract = contract;
      },
    },
  },
  components: {
    Datepicker,
    ImportModals,
    NoPermission,
    ApprovedModal,
    StepUploadImage,
    QuotationButtons,
    PaymentApprovedModal,
    PendingModal,
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    updateImage({ image, type }) {
      this.model.files[type] = image;
      this.$forceUpdate();
    },
    openPdfFromService(serviceCall) {
      this.setToggle({ type: 'progress', bool: true });
      serviceCall(this.$route.params.quotationId)
        .then(response => openPdf(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    printTechnicalAvaliation() {
      this.openPdfFromService(id => QuotationService.printTechnicalAvaliation(id));
    },
    printQuotation() {
      this.openPdfFromService(id => QuotationService.print(id));
    },
    declineQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.declineQuotation(this.model.id)
        .then(() => {
          this.activeAlert({ message: 'Orçamento cancelado com sucesso', theme: 'success' });
          this.$router.push({ name: 'admin-quotation-list', params: { page: 1 } });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    approveQuotation() {
      this.model.group_id = this.model.group ? this.model.group.id : null;
      if (this.checkForm()) {
        this.setToggle({ type: 'progress', bool: true });
        QuotationService.approveQuotation(this.model)
          .then(response => {
            this.setToggle({ type: 'approved_quotation_modal', bool: true });
            this.model = response;
            Events.$emit(_LOAD_MODEL_, response);
            this.$store.commit('setQuotation', response);
          })
          .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
          .finally(() => this.setToggle({ type: 'progress', bool: false }));
      }
    },
    paidQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.paidQuotation(this.model)
        .then(response => {
          this.setToggle({ type: 'payment_approved_quotation_modal', bool: true });
          this.model = response;
          Events.$emit(_LOAD_MODEL_, response);
          this.$store.commit('setQuotation', response);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
    pendingQuotation() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.pendingQuotation(this.model)
        .then(response => {
          this.setToggle({ type: 'pending_quotation_modal', bool: true });
          this.model = response;
          Events.$emit(_LOAD_MODEL_, response);
          this.$store.commit('setQuotation', response);
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
</script>

<style lang="scss" scoped>
.download-list {
  list-style: none;
  display: flex;
  justify-content: center;
  padding: 0;
  width: 100%;
  margin: 5px 0;
  li {
    width: 145px;
    border: 1px solid #DFE0E0;
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 15px;
    margin: 0 10px;
    font-size: 12px;
    color: #4F5F77;
    svg {
      margin-bottom: 10px;
      width: 40px;
      fill: #4F5F77;
    }
  }
}
</style>
